import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const VyhodnoceniPage = lazy(() =>
  import('@/modules/vozidla/VyhodnoceniPage').then((m) => ({ default: m.VyhodnoceniPage })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/vozidla/vyhodnoceni',
  component: () => (
    <Suspense fallback={null}>
      <VyhodnoceniPage />
    </Suspense>
  ),
});
